/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ListOfMcpSiteAssignmentDto } from './listOfMcpSiteAssignmentDto.schema';

export const MonthlyCoveragePlanDto = zod.object({
  "id": zod.string().uuid().optional(),
  "coordinatorId": zod.string().uuid().optional(),
  "coordinatorName": zod.string().optional(),
  "monthId": zod.number().optional(),
  "monthName": zod.string().optional(),
  "year": zod.number().optional(),
  "areaId": zod.number().optional(),
  "areaName": zod.string().optional(),
  "remarks": zod.string().optional(),
  "statusId": zod.number().optional(),
  "statusName": zod.string().optional(),
  "mcpSiteAssignments": zod.lazy(() => ListOfMcpSiteAssignmentDto).optional()
});

export type MonthlyCoveragePlanDto = zod.input<typeof MonthlyCoveragePlanDto>;
export type MonthlyCoveragePlanDtoOutput = zod.output<typeof MonthlyCoveragePlanDto>;
